import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BrowserPopupState {
  isBrowserPopupBlocked: boolean;
}

const browserPopupSlice = createSlice({
  name: "browserPopup",
  initialState: {
    isBrowserPopupBlocked: false,
  } as BrowserPopupState,
  reducers: {
    setBrowserPopupBlocked: (state: BrowserPopupState, action: PayloadAction<boolean>) => {
      state.isBrowserPopupBlocked = action.payload;
    },
  },
});

export const { setBrowserPopupBlocked } = browserPopupSlice.actions;
export default browserPopupSlice.reducer;
